import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _123Icon(props: IconProps) {
    return <Icon {...props} iconKey={"123"}/>
}
